<script>
import Slider from 'element-ui/lib/slider';

export default Slider;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/slider.css';
</style>
